import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import { INGREDIENT_GROUP, PN_STATIC_CATEGORY_SALARY_FOR_DRIVER, PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME, renderPageStyle } from "../../utils/Utils";

const PNReportMoneyFlowDriver = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });
  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    GET(`/ingredient`, {}, true).then((resp) => {
      setIngredients(resp.data.rows);
    });
  }, []);

  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      monthYear: filter.monthYear,
    }

    GET(
      `/pn/report-all-money-flow-driver`,
      params,
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [filter]);

  const colTable = [
    {
      Header: "Tên khách hàng",
      accessor: (item) => (
        <div
          className="cursor-pointer"
        >
          {item.name}
        </div>
      ),
    },

    ...(ingredients.filter(ingredient => ingredient.group === INGREDIENT_GROUP.STAFF).map((ingredient) => ({
      Header: `${ingredient.name}(đ)`,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item?.personalCostDetail?.[ingredient.id] || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    }))),
    {
      Header: "Lương cơ bản(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.baseSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Trợ cấp(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.totalAllowance || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Lương chuyến(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.driverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tổng trả(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.grossSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    ...(Object.values(PN_STATIC_CATEGORY_SALARY_FOR_DRIVER).map((ingredientId) => ({
      Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[ingredientId]}(đ)`,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item?.personalInDetail?.[ingredientId] || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    }))),
    {
      Header: "Tổng trừ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.cost || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Thực nhận(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.netSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/report-all-money-flow-driver-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <h5 className="text-center mt-2">Tổng hợp chi phí tài xế tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>
                    <style>{renderPageStyle({
                      fontSize: 7
                    })}</style>

                    <Table
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      headerRow={
                        <tr className="font-weight-bold">
                          <td>Tổng(đ)</td>
                          {/* <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.firstDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td> */}
                          {ingredients.filter(ingredient => ingredient.group === INGREDIENT_GROUP.STAFF).map((ingredient) =>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                value={summary?.personalCostDetail?.[ingredient.id] || 0}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            </td>
                          )}
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.baseSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.totalAllowance || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>

                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.driverBonus || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.grossSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>

                          {Object.values(PN_STATIC_CATEGORY_SALARY_FOR_DRIVER).map((ingredientId) =>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                value={summary?.personalInDetail?.[ingredientId] || 0}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            </td>
                          )}
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.cost || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.netSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                        </tr>
                      }
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
      </Content>

    </React.Fragment>
  );
};

export default PNReportMoneyFlowDriver;
